import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, insideImages } from '../data/content';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(insideImages.length - 1, i));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      setIndex(Math.max(0, Math.min(insideImages.length - 1, i)));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-carbon px-3 py-4 sm:px-6" data-id="element-95" data-mp="a2o3oog3rxft">
      <div className="mx-auto max-w-2xl" data-id="element-96" data-mp="a138qxpvmchf">
        <h2 className="text-center font-display text-[1.7rem] font-bold uppercase leading-none text-white sm:text-[2.3rem]" data-id="element-97" data-mp="612vhgeik7by">
          LOOK <span className="text-volt" data-id="element-98" data-mp="k13tmo3e90nq">INSIDE</span>
        </h2>
        <p className="mt-1 text-center text-[0.78rem] font-extrabold uppercase tracking-wide text-volt sm:text-[0.92rem]" data-id="element-99" data-mp="f1raadbqebpw">
          See GENERATOR DIAGNOSTIC PRO™ In Action
        </p>
        <p className="mt-1 text-center text-[0.78rem] leading-[1.35] text-steel sm:text-[0.9rem]" data-id="element-100" data-mp="3nfhop9rmy3lv">
          Take a look inside the system and see the diagnostic workflows, symptom-based
          troubleshooting paths, measurement references, fault-finding charts, testing records,
          decision trees and ready-to-use technician resources included.
        </p>

        <div className="relative mt-2" data-id="element-101" data-mp="34prvgr3itpw2">
          <div ref={trackRef} className="flex snap-x snap-mandatory overflow-x-auto rounded-md border-2 border-volt bg-graphite [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" role="group" aria-roledescription="carousel" aria-label="Interior pages of Generator Diagnostic Pro" tabIndex={0} data-id="element-102" data-mp="2zrzvd9sq2xgs">
            {insideImages.map((img, i) => <a key={img.src} href={PURCHASE_ANCHOR} className="flex w-full shrink-0 snap-center items-center p-1.5" aria-label={`Page ${i + 1} of ${insideImages.length} — get the complete system`} data-id="element-103" data-mp="1heymob5a9srg" data-mpi={i}>
                <img src={img.src} alt={img.alt} loading={i === 0 ? 'eager' : 'lazy'} className="mx-auto w-full rounded-sm bg-carbon shadow-md" data-id="element-104" data-mp="tqe9gn7gtkfy" />
              </a>)}
          </div>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1 top-1/2 -translate-y-1/2 rounded-full border-2 border-volt bg-carbon/90 p-1.5 text-volt shadow-md transition-colors duration-150 ease-out hover:bg-carbon disabled:opacity-30" data-id="element-105" data-mp="2a4nourtqbyun">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-106" data-mp="26hpil5i08yn6" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === insideImages.length - 1} aria-label="Next page" className="absolute right-1 top-1/2 -translate-y-1/2 rounded-full border-2 border-volt bg-carbon/90 p-1.5 text-volt shadow-md transition-colors duration-150 ease-out hover:bg-carbon disabled:opacity-30" data-id="element-107" data-mp="21icxap6s7zmp">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-108" data-mp="3lxy3v3rkj7bp" />
          </button>
        </div>

        <div className="mt-1.5 flex items-center justify-center gap-1.5" data-id="element-109" data-mp="3hww32ii06n7m">
          {insideImages.map((img, i) => <button key={img.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1}`} aria-current={i === index} className={`h-1.5 rounded-full transition-[width,background-color] duration-150 ease-out ${i === index ? 'w-5 bg-volt' : 'w-1.5 bg-steel/40'}`} data-id="element-110" data-mp="3ozjdojd87vfo" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}